import { computed, toRefs, watch } from 'vue';
import { hasProp } from 'utils';

import bokalSourage from 'services/bokalSourage';
import ReactiveFetch from 'utils/ReactiveFetch';

export function syncDataToLocalStorage (lsKey, state) {
  const lastData = bokalSourage.get(lsKey);
  if (lastData)
    state.data = lastData;

  watch(state, (state) => {
    if (!state.meta || state.meta.pending)
      return;
    bokalSourage.set(lsKey, state.data);
  });
}

export function removeItem (arr, item) {
  if (!arr || !arr.length || item == undefined)
    return;
  const i = arr.indexOf(item);
  if (~i) {
    arr.splice(i, 1);
    return i;
  }
  else return false;
}

export function memoizeById (state) {
  const cache = {};
  return (id) => {
    if (hasProp(id)) {
      const item = cache[id];
      if (item.$deleted) {
        delete cache[id];
        return null;
      }
      return item;
    }
    const item = state.data?.find(item => item.id === id);
    if (!item)
      return null;
    cache[id] = item;
    return item;
  };
}

export function computedMapById (state) {
  return computed(
    () => (state.data || []).reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {}),
  );
}

export const resActs = {
  add (item, opts) {
    const req = this._actReqs.add(item, opts);
    // this.state.data?.unshift(item);
    req.then(({ data }) => {
      const _item = Object.assign(item, data, { $created: Date.now() });
      this.state.data?.unshift(_item);
      // if (Array.isArray(this.state.data)) {
      //   const i = this.state.data.indexOf(item);
      //   this.state.data[i] = _item;
      // }
    });
    // req.catch(err => removeItem(this.state.data, item));
    return req;
  },

  get (opts) {
    const req = this._actReqs.get(opts);
    req.then(({ data: item }) => {
      if (!this.state.data?.length)
        return;
      const i = this.state.data.findIndex(({ id }) => id === item.id);
      this.state.data[i] = item;
    });
    return req;
  },

  delete (item, opts) {
    const req = this._actReqs.delete(item, opts);
    const existentInd = this.state.data?.findIndex(({ id }) => id === item.id);
    if (~existentInd) {
      req.then(() => {
        const existent = this.state.data[existentInd];
        existent.$deleted = Date.now();
        setTimeout(() => {
          removeItem(this.state.data, existent);
        }, 10);
      });
    }
    return req;
  },

  update (item, opts) {
    const req = this._actReqs.update(item, opts);
    const existent = this.state.data?.find(({ id }) => id === item.id);
    if (existent)
      req.then(({ data: nextItem }) => Object.assign(existent, nextItem, { $updated: Date.now() }));
    return req;
  },

  fetch ({ preserveData, ...reqOpts } = {}) {
    if (this.state.meta?.pending)
      return this.state.meta.request;
    const rf = new ReactiveFetch(
      this._actReqs.fetch(reqOpts),
      preserveData ? { data: this.state.data } : undefined,
    );
    Object.assign(this.state, toRefs(rf));
    return rf.meta.request;
  },

  reset () {
    Object.assign(this.state, toRefs(new ReactiveFetch()));
  },
};
